import { Table } from "@pentabd/ui";
import { useTranslation } from "react-i18next";
import { SoftwareHistoryTableColumn } from "./SoftwareHistoryTableColumn";
import { useEffect, useState } from "react";
import SoftwareHistoryModal from "./SoftwareHistoryModal";

const SoftwareHistory = ({ data, id }: any) => {
  const { t } = useTranslation();

  const [openModal, setOpenModal] = useState(false);
  const [historyId, setHistoryId] = useState<number | null>(null);

  const openHistoryModalHandler = (historyId: number | null) => {
    setOpenModal(true);
    setHistoryId(historyId);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    const reset = () => {
      setOpenModal(false);
    };
    reset();
  }, []);

  return (
    <div className="my-20">
      {/* software history modal  */}

      <SoftwareHistoryModal
        id={id}
        historyId={historyId}
        openModal={openModal}
        closeModal={closeModal}
      />

      <Table
        header={{
          title: t("SOFTWARE_INVENTORY.SOFTWARE_HISTORY.HEADER"),
        }}
        columns={SoftwareHistoryTableColumn(t, data, openHistoryModalHandler)}
        rows={data?.softwareHistory || []}
      />
    </div>
  );
};

export default SoftwareHistory;
